import {
  BrowserRouter, Navigate, Routes, Route, HashRouter,
} from 'react-router-dom';
import { Worker } from '@react-pdf-viewer/core';
import MainLayout from '../layouts/MainLayout';
import ConsoleLayout from '../layouts/ConsoleLayout';
import Home from '../pages/Home';
import Login from '../pages/Login';
import ReVerify from '../pages/ReVerify';
import Signup from '../pages/Signup';
import InformalSignup from '../pages/informal/InformalSignUp';
import VerifyAccount from '../pages/VerifyAccount';
import ForgotPassword from '../pages/ForgotPassword';
import NotFound from '../pages/NotFound';
import Dashboard from '../pages/console/Dashboard';
import Statement from '../pages/console/Statement';
import MemberCard from '../pages/console/MemberCard';
import Complaint from '../pages/console/Complaint';
import AuthProvider from '../hooks/AuthProvider';
import Reset from '../pages/console/Reset';
import Claim from '../pages/console/Claim';
import Contribution from '../pages/console/Contribution';
import UpdateNida from '../pages/console/UpdateNida';
import VerifyForgotPassword from '../pages/VerifyForgotPassword';
import SetPassword from '../pages/SetPassword';

function App() {
  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
    <HashRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route path="" element={<Home />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            <Route path="forgot" element={<ForgotPassword />} />
            <Route path="reverify" element={<ReVerify />} />
            <Route path="verify" element={<VerifyAccount />} />
            <Route path="not-found" element={<NotFound />} />
            <Route path="informal-sign-up" element={<InformalSignup />} />
            <Route path="verify-forgot-password" element={<VerifyForgotPassword />} />
            <Route path="set-password" element={<SetPassword />} />
            <Route path="*" element={<Navigate to="/not-found" />} />
          </Route>
          <Route path="console" element={<ConsoleLayout />}>
            <Route path="" element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="contribution" element={<Contribution/>} />
            <Route path="statement" element={<Statement/>} />
            <Route path="benefit" element={<Claim/>} />
            <Route path="card" element={<MemberCard />} />
            <Route path="complaint" element={<Complaint />} />
            <Route path="update-nida" element={<UpdateNida />} />
            <Route path="reset" element={<Reset />} />
          </Route>
        </Routes>
      </AuthProvider>
    </HashRouter>
    </Worker>
  );
}

export default App;
